module.exports = __webpack_public_path__ + "img/advantage3@2x.69f555c6.png";